/**
 * react-native-web dropped its AsyncStorage.
 */

var isObject = function(value)
{
  return value !== null && typeof value === 'object';
};

var deepAssign = function(target)
{
  for( var i = 1; i < arguments.length; i++ )
  {
    var source = arguments[i];
    if( !isObject(source) ) continue;

    Object.keys(source).forEach(function(key)
    {
      var oldValue = target[key];
      var newValue = source[key];

      if( isObject(oldValue) && isObject(newValue) ) target[key] = deepAssign(Array.isArray(oldValue) ? [] : {}, oldValue, newValue);
      else target[key] = newValue;
    });
  }

  return target;
};

var mergeLocalStorageItem = function(key, value)
{
  var oldValue = window.localStorage.getItem(key);
  var oldObject = JSON.parse(oldValue);
  var newObject = JSON.parse(value);
  var nextValue = JSON.stringify(deepAssign({}, oldObject, newObject));
  window.localStorage.setItem(key, nextValue);
};

var createPromise = function(getValue, callback)
{
  return new Promise(function(resolve, reject)
  {
    try
    {
      var value = getValue();
      if( callback ) callback(null, value);
      resolve(value);
    }
    catch (err)
    {
      if( callback ) callback(err);
      reject(err);
    }
  });
};

var createPromiseAll = function(promises, callback, processResult)
{
  return Promise.all(promises).then(function(result)
  {
    var value = processResult ? processResult(result) : null;
    callback && callback(null, value);
    return Promise.resolve(value);
  }, function(errors)
  {
    callback && callback(errors);
    return Promise.reject(errors);
  });
};

var AsyncStorage = {};

AsyncStorage.clear = function(callback)
{
  return createPromise(function()
  {
    window.localStorage.clear();
  }, callback);
};

AsyncStorage.flushGetRequests = function() {};

AsyncStorage.getAllKeys = function(callback)
{
  return createPromise(function()
  {
    var numberOfKeys = window.localStorage.length;
    var keys = [];
    for( var i = 0; i < numberOfKeys; i += 1 )
    {
      keys.push(window.localStorage.key(i));
    }
    return keys;
  }, callback);
};

AsyncStorage.getItem = function(key, callback)
{
  return createPromise(function()
  {
    return window.localStorage.getItem(key);
  }, callback);
};

AsyncStorage.multiGet = function(keys, callback)
{
  var promises = keys.map(function(key) { return AsyncStorage.getItem(key); });
  var processResult = function(result)
  {
    return result.map(function(value, i) { return [keys[i], value]; });
  };
  return createPromiseAll(promises, callback, processResult);
};

AsyncStorage.setItem = function(key, value, callback)
{
  return createPromise(function()
  {
    window.localStorage.setItem(key, value);
  }, callback);
};

AsyncStorage.multiSet = function(keyValuePairs, callback)
{
  var promises = keyValuePairs.map(function(item) { return AsyncStorage.setItem(item[0], item[1]); });
  return createPromiseAll(promises, callback);
};

AsyncStorage.mergeItem = function(key, value, callback)
{
  return createPromise(function()
  {
    mergeLocalStorageItem(key, value);
  }, callback);
};

AsyncStorage.multiMerge = function(keyValuePairs, callback)
{
  var promises = keyValuePairs.map(function(item) { return AsyncStorage.mergeItem(item[0], item[1]); });
  return createPromiseAll(promises, callback);
};

AsyncStorage.removeItem = function(key, callback)
{
  return createPromise(function()
  {
    return window.localStorage.removeItem(key);
  }, callback);
};

AsyncStorage.multiRemove = function(keys, callback)
{
  var promises = keys.map(function(key) { return AsyncStorage.removeItem(key); });
  return createPromiseAll(promises, callback);
};

module.exports = AsyncStorage;
